import type { Reaction } from './types';

export type LimitedReaction = Extract<Reaction, 'CELEBRATE' | 'LAUGH' | 'LIKE' | 'LOVE' | 'SAD' | 'THANK'>;

// istanbul ignore next
export const limitedReactions: LimitedReaction[] = ['CELEBRATE', 'LAUGH', 'LIKE', 'LOVE', 'SAD', 'THANK'];
